var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowforward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9819_1761",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9819_1761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8558 10.625H4.375C4.19765 10.625 4.04915 10.5652 3.9295 10.4455C3.80983 10.3259 3.75 10.1774 3.75 10C3.75 9.8227 3.80983 9.6742 3.9295 9.55454C4.04915 9.43489 4.19765 9.37507 4.375 9.37507H13.8558L9.54806 5.06736C9.42413 4.94343 9.36297 4.7984 9.36458 4.63227C9.36618 4.46614 9.43162 4.31843 9.5609 4.18917C9.69016 4.06845 9.83652 4.00595 9.99998 4.00167C10.1634 3.99739 10.3098 4.05989 10.4391 4.18917L15.7227 9.47282C15.8007 9.5508 15.8557 9.63307 15.8878 9.71961C15.9198 9.80614 15.9359 9.89961 15.9359 10C15.9359 10.1005 15.9198 10.194 15.8878 10.2805C15.8557 10.367 15.8007 10.4493 15.7227 10.5273L10.4391 15.8109C10.3237 15.9263 10.1808 15.9853 10.0104 15.988C9.83999 15.9907 9.69016 15.9316 9.5609 15.8109C9.43162 15.6817 9.36698 15.5332 9.36698 15.3654C9.36698 15.1977 9.43162 15.0492 9.5609 14.9199L13.8558 10.625Z",
    fill: "#8E969C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowforward);
export default __webpack_public_path__ + "static/media/arrowforward.ed434882f9a8e2d3095e5753eb4bc431.svg";
export { ForwardRef as ReactComponent };